import { useEffect, useState } from "react";
import { listCountries } from "../../lib/ephemeris/cityLookup";

type Props = {
  id: string;
  label: string;
  value: string;
  onChange: (countryCode: string) => void;
  required?: boolean;
};

/**
 * Country dropdown for the birth-chart form — previously missing entirely
 * (see chart.ts's BirthInput/cityLookup.ts's findCity() headers for why an
 * ambiguous city name without a country can resolve to the wrong
 * country/timezone). Defaults to "DE" (Germany), our primary market, so
 * existing users filling in a German city don't need to touch this field
 * at all; it's just no longer silently assumed.
 */
export function CountrySelect({ id, label, value, onChange, required }: Props) {
  const [countries, setCountries] = useState<{ code: string; name: string }[]>([]);

  useEffect(() => {
    listCountries().then(setCountries);
  }, []);

  return (
    <div className="flex flex-col gap-1.5 text-left">
      <label htmlFor={id} className="text-xs font-medium tracking-wide text-obsidian/60">
        {label}
      </label>
      <select
        id={id}
        required={required}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full rounded-xl border border-slate-200 bg-white/90 px-4 py-3 text-charcoal outline-none transition-colors duration-200 focus:border-gold focus:bg-white"
      >
        {countries.length === 0 && <option value={value}>{value || "Lade …"}</option>}
        {countries.map((c) => (
          <option key={c.code} value={c.code}>
            {c.name}
          </option>
        ))}
      </select>
    </div>
  );
}
